<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';

    export let ctaVisible = false;
    export let message = '';
    export let btnText = '';
    export let btnColor = '';
    export let btnBgColor = '';
    export let onBtnClick: () => void;
    export let onBtnMouseEnter: () => void;

    const videoBorderRadiusClass = getBorderRadius('video');
</script>

<div class={cn('actions', videoBorderRadiusClass, 'fun-rounded-t-none')}>
    <div class="animationContainer" class:fun-visible={ctaVisible}>
        <div class="message">{message}</div>
        <div class="message flexEnd">
            <button
                on:click={onBtnClick}
                on:mouseenter={onBtnMouseEnter}
                on:touchstart={onBtnMouseEnter}
                class="button"
                style="background: {btnBgColor}; color: {btnColor}"
            >
                {btnText}
            </button>
        </div>
    </div>
</div>

<style lang="scss">
    @import '../_utils/variables';

    .actions {
        background-color: black;
        height: 82px;
        overflow: hidden;

        .animationContainer {
            transform: translateY(0);

            &.visible {
                -webkit-animation: slide-top 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
                animation: slide-top 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
            }
        }

        .message {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 82px;
            width: 100%;
            transition: all 400ms ease-in-out;
            padding: 8px;
            box-sizing: border-box;
            color: $grey3;

            &.flexEnd {
                align-items: flex-end;
            }

            .button {
                padding: 18px 24px;
                border-radius: 6px;
                display: inline-block;
                cursor: pointer;
                box-shadow: 0 0 1px rgba(0, 0, 0, 0.5) inset;
                border: none;
                width: 100%;
                transition:
                    0.2s background-color,
                    0.2s transform;
                margin-bottom: 0;
                font-weight: 600;
                font-size: 16px;
            }
        }
    }
</style>
